const flybuysTheme = {
  primary: "#1E71AB",
  bgColor: "#007CC2",
};

export default flybuysTheme;
